import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import Cards from './cards/Cards';
import '../../styles/pt/pt-trials.css';
import '../../styles/home/home.css';
import { selectAuth } from '../../components/auth/auth.selector';
import Cards2 from './cards/Cards2';
import GlobalCardFilters from './common/GlobalCardFilters';
import SaleValues from './tables/SaleValues';
import HelmetWrapper from '../../HelmetWrapper';
import ReloadButton from '../../components/Open-pages/common/ReloadButton';
import CmnFilters from '../../components/lead-management/common/CmnFilters';

const Home = () => {
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};

  const apiCallRefs = useRef([]);

  const isAdmin = user?.account_type === 'admin';
  const isGym = user?.account_type === 'gym';

  const isManagerRole = [
    'cluster_manager',
    'fitness_manager',
    'sales_manager',
    'club_manager',
  ].includes(user?.account_type);

  const iniAllFilters = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? user?.name : user?.gym_name || '',
            value: user?.gym_id || user?.uid || user?.user_id || '',
          }
        : '',
    selAddedby: '',
    isToggledValue: true,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    gym_id: !isAdmin && !isManagerRole ? user?.gym_id || user?.uid || user?.user_id : '',
    cluster_manager_id: allFilters.selAddedby?.value || '',
  };
  const [filters, setFilters] = useState(iniFilters);

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
  };

  const registerApiCall = (apiCall) => {
    if (!apiCallRefs.current.includes(apiCall)) {
      apiCallRefs.current.push(apiCall);
    }
  };

  const handleReload = () => {
    apiCallRefs.current.forEach((apiCall) => apiCall());
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id:
        !isAdmin && !isManagerRole
          ? user?.gym_id || user?.uid || user?.user_id
          : allFilters.selectedGym?.value || '',
      cluster_manager_id: allFilters.selAddedby?.value || '',
    }));
  }, [allFilters.selectedGym, user?.gym_id, allFilters.selAddedby]);

  return (
    <HelmetWrapper title="WTF: Home">
      <Container fluid className="px-50px pb-50px home-container">
        <Row>
          <Col>
            {allFilters.isToggledValue ? (
              <CmnFilters
                from="home-global"
                userInfoData={user}
                onClickReset={onClickReset}
                filters={allFilters}
                setFilters={setAllFilters}
                isReload={handleReload}
              />
            ) : (
              <>
                {!isAdmin ? <ReloadButton onClickReload={handleReload} /> : null}

                <GlobalCardFilters
                  user={user}
                  allFilters={allFilters}
                  setAllFilters={setAllFilters}
                  onClickReset={onClickReset}
                  isTop={true}
                  isReload={isAdmin ? handleReload : null}
                />
              </>
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <Cards2
              user={user}
              filters={filters}
              allFilters={allFilters}
              registerApiCall={registerApiCall}
              isBetaMode={allFilters.isToggledValue}
            />
          </Col>
        </Row>

        <Cards
          user={user}
          filters={filters}
          setFilters={setFilters}
          allFilters={allFilters}
          registerApiCall={registerApiCall}
          isBetaMode={allFilters.isToggledValue}
        />

        {isAdmin || isManagerRole ? (
          <Row>
            <Col>
              <SaleValues
                user={user}
                gymId={filters.gym_id}
                registerApiCall={registerApiCall}
                isBetaMode={allFilters.isToggledValue}
                prevAllFilters={allFilters}
              />
            </Col>
          </Row>
        ) : null}
      </Container>
    </HelmetWrapper>
  );
};

export default Home;